var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        { attrs: { outlined: "", elevation: "1" } },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", dense: "", flat: "" } },
            [
              _c("v-toolbar-title", [_vm._v("Edit Completion Report")]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "white", small: "", text: "" },
                  on: {
                    click: function($event) {
                      return _vm.printReport(_vm.reportId)
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-printer")
                  ]),
                  _vm._v(" Print ")
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "white",
                    small: "",
                    text: "",
                    to: "/completion-reports"
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-arrow-left")
                  ]),
                  _vm._v(" Back ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                { ref: "formRef" },
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              disabled: "",
                              outlined: "",
                              "hide-details": "",
                              dense: "",
                              label: "Reference No"
                            },
                            model: {
                              value: _vm.inputs.ref_no,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs, "ref_no", $$v)
                              },
                              expression: "inputs.ref_no"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "hide-details": "",
                              dense: "",
                              type: "date",
                              label: "Date"
                            },
                            model: {
                              value: _vm.inputs.date,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs, "date", $$v)
                              },
                              expression: "inputs.date"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              outlined: "",
                              "hide-details": "",
                              dense: "",
                              label: "Customer",
                              "item-value": "id",
                              "item-text": item => `${item.id} - ${item.name}`,
                              items: _vm.customers
                            },
                            model: {
                              value: _vm.inputs.customer_id,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs, "customer_id", $$v)
                              },
                              expression: "inputs.customer_id"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "hide-details": "",
                              dense: "",
                              label: "Project Name"
                            },
                            model: {
                              value: _vm.inputs.project_name,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs, "project_name", $$v)
                              },
                              expression: "inputs.project_name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-textarea", {
                            attrs: {
                              outlined: "",
                              "hide-details": "",
                              dense: "",
                              label: "Description",
                              rows: "3",
                              "auto-grow": ""
                            },
                            model: {
                              value: _vm.inputs.description,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs, "description", $$v)
                              },
                              expression: "inputs.description"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "label",
                            { staticClass: "font-weight-bold mb-2 d-block" },
                            [_vm._v("Scope of Works")]
                          ),
                          _vm._l(_vm.inputs.scope_of_works, function(
                            item,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: "scope-" + index,
                                staticClass: "d-flex align-center mb-2"
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "flex-grow-1 mr-2",
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    placeholder: "Enter scope item"
                                  },
                                  model: {
                                    value: _vm.inputs.scope_of_works[index],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.inputs.scope_of_works,
                                        index,
                                        $$v
                                      )
                                    },
                                    expression: "inputs.scope_of_works[index]"
                                  }
                                }),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "", color: "red" },
                                    on: {
                                      click: function($event) {
                                        return _vm.inputs.scope_of_works.splice(
                                          index,
                                          1
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("mdi-delete")])],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _c(
                            "v-btn",
                            {
                              attrs: { small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.inputs.scope_of_works.push("")
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-plus")
                              ]),
                              _vm._v(" Add Scope Item ")
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "label",
                            { staticClass: "font-weight-bold mb-2 d-block" },
                            [_vm._v("Work Completed")]
                          ),
                          _vm._l(_vm.inputs.work_completed, function(
                            item,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: "completed-" + index,
                                staticClass: "d-flex align-center mb-2"
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "flex-grow-1 mr-2",
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    placeholder: "Enter completed work item"
                                  },
                                  model: {
                                    value: _vm.inputs.work_completed[index],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.inputs.work_completed,
                                        index,
                                        $$v
                                      )
                                    },
                                    expression: "inputs.work_completed[index]"
                                  }
                                }),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "", color: "red" },
                                    on: {
                                      click: function($event) {
                                        return _vm.inputs.work_completed.splice(
                                          index,
                                          1
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("mdi-delete")])],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          _c(
                            "v-btn",
                            {
                              attrs: { small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.inputs.work_completed.push("")
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-plus")
                              ]),
                              _vm._v(" Add Completed Item ")
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-textarea", {
                            attrs: {
                              outlined: "",
                              "hide-details": "",
                              dense: "",
                              label: "Conclusion",
                              rows: "3",
                              "auto-grow": ""
                            },
                            model: {
                              value: _vm.inputs.conclusion,
                              callback: function($$v) {
                                _vm.$set(_vm.inputs, "conclusion", $$v)
                              },
                              expression: "inputs.conclusion"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-subtitle-2 font-weight-bold mb-2"
                            },
                            [_vm._v("Images")]
                          ),
                          _vm._l(_vm.imageRows, function(row, rowIndex) {
                            return _c(
                              "v-row",
                              {
                                key: "row-" + rowIndex,
                                attrs: { dense: "", align: "start" }
                              },
                              _vm._l(row, function(img, i) {
                                return _c(
                                  "v-col",
                                  {
                                    key: "img-" + rowIndex + "-" + i,
                                    attrs: {
                                      md: Math.floor(
                                        _vm.spanToNumber(img.span) * 12
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex flex-column",
                                        staticStyle: { gap: "10px" }
                                      },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            label: "Image Name"
                                          },
                                          model: {
                                            value: img.name,
                                            callback: function($$v) {
                                              _vm.$set(img, "name", $$v)
                                            },
                                            expression: "img.name"
                                          }
                                        }),
                                        _c("v-select", {
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            label: "Span",
                                            items: _vm.spanOptions,
                                            "item-text": "label",
                                            "item-value": "value"
                                          },
                                          model: {
                                            value: img.span,
                                            callback: function($$v) {
                                              _vm.$set(img, "span", $$v)
                                            },
                                            expression: "img.span"
                                          }
                                        }),
                                        _c("v-file-input", {
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            "prepend-inner-icon": "mdi-image",
                                            accept: "image/*"
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.onFileChange(
                                                $event,
                                                img
                                              )
                                            }
                                          }
                                        }),
                                        img.preview
                                          ? _c("v-img", {
                                              staticClass: "mt-2",
                                              attrs: {
                                                src: img.preview,
                                                "max-height": "200",
                                                contain: ""
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "mt-1",
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          color: "red"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeImage(img)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("mdi-close")
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          }),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-2",
                              attrs: {
                                small: "",
                                color: "blue darken-1",
                                dark: ""
                              },
                              on: { click: _vm.addImage }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-plus")
                              ]),
                              _vm._v(" Add Image ")
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c("v-divider", { staticClass: "my-4" }),
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { block: "", color: "primary", dark: "" },
                              on: { click: _vm.updateReport }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-content-save")
                              ]),
                              _vm._v(" Update ")
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                block: "",
                                color: "blue darken-2",
                                dark: "",
                                to: "/completion-reports"
                              }
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-file-document")
                              ]),
                              _vm._v(" Reports ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }